import {createI18n} from 'vue-i18n';

// Load all locales and remember context
async function loadMessages() {
    const context = import.meta.glob("./locales/*.json");

    const messages = {};

    for (const key in context) {
        const locale = key.match(/([a-z]{2})\.json$/)[1];
        messages[locale] = await context[key]();
    }

    return {context, messages};
}

export async function setupI18n(locale) {

    const {context, messages} = await loadMessages();

    const i18n = createI18n({
        allowComposition: true,
        legacy: false,
        locale,
        fallbackLocale: 'en',
        messages,
    });

    // Hot updates
    if (import.meta.hot) {
        import.meta.hot.accept(Object.keys(context), () => {
            const {messages: newMessages} = loadMessages();

            Object.keys(newMessages)
                .filter((locale) => messages[locale] !== newMessages[locale])
                .forEach((locale) => {
                    messages[locale] = newMessages[locale];
                    i18n.global.setLocaleMessage(locale, messages[locale]);
                });
        });
    }
    return i18n;
}

/*
// TODO: Anpassen!!!

import { nextTick } from 'vue'
import { createI18n } from 'vue-i18n'

export const SUPPORT_LOCALES = ['en', 'ja']

export function setupI18n(options = { locale: 'en' }) {
    const i18n = createI18n(options)
    setI18nLanguage(i18n, options.locale)
    return i18n
}

export function setI18nLanguage(i18n, locale) {
    if (i18n.mode === 'legacy') {
        i18n.global.locale = locale
    } else {
        i18n.global.locale.value = locale
    }
    /**
     * NOTE:
     * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
     * The following is an example for axios.
     *
     * axios.defaults.headers.common['Accept-Language'] = locale
     * /
    document.querySelector('html').setAttribute('lang', locale)
}

export async function loadLocaleMessages(i18n, locale) {
    // load locale messages with dynamic import
    const messages = await import(
        /* webpackChunkName: "locale-[request]" * / `./locales/${locale}.json`
        )

    // set locale and locale message
    i18n.global.setLocaleMessage(locale, messages.default)

    return nextTick()
}
*/